module.exports = __webpack_public_path__ + "img/voice.71ceeb06.svg";